<script>
import Vue from 'vue'
import { Notifications } from '@/api/notification'
import Modal from '../../../components/atoms/Modal.vue'
import ButtonLoader from '@/components/atoms/ButtonLoader.vue'
const notifications = Vue.observable(new Notifications(Vue.prototype.$isSupported))

export default {
    name: 'NotificationModal',
    components: { Modal, ButtonLoader },
    data() {
        return {
            allowLoading: false,
        }
    },
    computed: {
        notifications: () => notifications,
        isDecided() {
            return this.notifications.isDecided
        },
        isAllowed() {
            return this.notifications.notificationsAllowed
        },
        isDisabled() {
            return Notification.permission === 'denied'
        },
        supportedPush() {
            return this.notifications.supportedPush
        },
        allowedForUser() {
            return (
                this.$user.model.notification_settings.canteen_push ||
                this.$user.model.notification_settings.delivery_push
            )
        },
    },
    methods: {
        allowForUser() {
            if (!this.$user.model.notification_settings.delivery_push) {
                this.$user.model.notification_settings.delivery_push = true
                this.$user.update(this.$user.model)
            }
        },
        openModal() {
            this.$refs.notificationModal.openModal()
        },
        allow() {
            this.allowLoading = true
            this.allowForUser()
            this.notifications
                .register()
                .then(() => {
                    this.$store.dispatch('toastInfo', {
                        title: this.$t('base.success'),
                        text: this.$t('notification_modal.success'),
                        button: {
                            to: { name: 'profile-notifications' },
                            label: this.$t('profile.pages.preferences'),
                            $router: this.$router,
                        },
                    })
                })
                .finally(() => {
                    this.allowLoading = false
                    this.$refs.notificationModal.closeModal()
                    this.$emit('changed')
                })
        },
        closeForNow() {
            this.notifications.closeForNow()
            this.$refs.notificationModal.closeModal()
            this.$emit('changed')
        },
    },
}
</script>

<template lang="pug">
modal(ref="notificationModal" v-if="isDisabled")
    template(v-slot:body)
        .d-flex.align-items-center.flex-column
            icon.mb-6(style="font-size:50px" icon="fa-solid fa-exclamation-triangle")
            .modal-header-text.mb-6 {{$t('notification_modal_disabled.title')}}
            .p-4 {{ $t('notification_modal_disabled.subtitle') }}
    template(v-slot:footer)
        button(@click="closeForNow").btn.btn-secondary {{ $t('notification_modal_disabled.ok') }}
modal(ref="notificationModal" v-else)
    template(v-slot:header)
        .modal-header-text {{$t('notification_modal.title')}}
    template(v-slot:body)
        div {{ $t('notification_modal.subtitle') }}
    template(v-slot:footer)
        button(@click="closeForNow").btn.btn-secondary {{ $t('notification_modal.cancel') }}
        button-loader.btn.btn-primary(@click="allow" :loading="allowLoading" :disabled="allowLoading") {{ $t('notification_modal.allow') }}
</template>
